import { getWithExceptions } from "api/apiRequest";

export function fetchCurrenciesSupported(): Promise<{
  stripeSupportedCurrenciesMappings: Array<{
    currency: string;
    platformCountry: string;
    country: string;
  }>;
}> {
  return getWithExceptions("/SleekPay/supported-currencies", { param: {} });
}
